import { enumByIdentifier, enums, items } from "@/fx/data-helpers";

//CLIFF: This is outside of CLM because it is referenced in the proxy.ts file.

const boomHostName   = process.env.NEXT_PUBLIC_HOST_NAME_BOOM;
const claimsHostName = process.env.NEXT_PUBLIC_HOST_NAME_CLAIMS;

const hostnamesMatch = boomHostName === claimsHostName;

const shouldNotRewriteBasePath = hostnamesMatch;

export type App = {
  identifier: string;
  name:       string;
  pathname:   string;
  hostname:   string;
};
export const App = enums({
  CLAIMS_DIS:     { identifier: "CLAIMS_DIS",     name: "Claims",       pathname: shouldNotRewriteBasePath ? '/claims-app/distributors/' : '/', hostname: claimsHostName },
  CLAIMS_BBC_APR: { identifier: "CLAIMS_BBC_APR", name: "Claims",       pathname:                            '/claims-app/approvers/',          hostname: boomHostName   },
  TRACKER:        { identifier: "TRACKER",        name: "Claims",       pathname:                            '/tracker/',                       hostname: boomHostName   },
  DEVELOPER_TOOLS:{ identifier: "DEVELOPER_TOOLS",name: "Dev Tools",    pathname:                            '/developer-tools/',               hostname: boomHostName   },
  HUD:            { identifier: "HUD",            name: "HUD",          pathname:                            '/hud/',                           hostname: boomHostName   },
  HEALTH_CHECK:   { identifier: "HEALTH_CHECK",   name: "Health Check", pathname:                            '/health-check/',                  hostname: boomHostName   },
  PORTAL:         { identifier: "PORTAL",         name: "Portal",       pathname:                            '/portal/',                        hostname: boomHostName   },
  SITE_MAP:       { identifier: "SITE_MAP",       name: "Site Map",     pathname:                            '/sitemap/',                       hostname: boomHostName   },
  ROOT:           { identifier: "ROOT",           name: "Root",         pathname:                            '/',                               hostname: boomHostName   },
});
export const apps = items<App>(App);
export const app  = enumByIdentifier(apps);

const isRootPathname     = (_: App): boolean => _.pathname === '/';

export const currentApp = ({ hostname, pathname }: { hostname: string; pathname: string }): App | undefined => {
  const pathnameStartsWith = (_: App): boolean => pathname.toLocaleLowerCase().indexOf(_.pathname) == 0;
  const appFromPathname    = (_: App): boolean => !isRootPathname(_) && pathnameStartsWith(_);
  const isClaimsHostname   = !hostnamesMatch && hostname === claimsHostName;

  const matchingApps = apps.filter(appFromPathname);

  // CLIFF middleware does not like assert for some reason
  if(matchingApps.length > 1) {
    throw new Error(`More than one entry matching current path: ${pathname}`);
  }
  else if(matchingApps.length === 1) {
    return matchingApps[0];
  }
  else if(isClaimsHostname) {
    return App.CLAIMS_DIS;
  }

  return undefined;
};

export type CurrentAppInfo = {
  currentApp:        App | undefined;
  isAppRoot:         boolean;
  isClaimsApp:       boolean;
  isAdminApp:        boolean;
  inClaims:          boolean;
  isAppNoAccessPage: boolean;
  claimId:           string | undefined;
};

export const currentAppInfo = ({ hostname, pathname }: { hostname: string; pathname: string }): CurrentAppInfo => {
  const segments          = pathname.split('/').filter((segment) => segment.length);
  const loweredSegments   = segments.map(_ => _.toLocaleLowerCase());
  const isAppRoot         = loweredSegments.length === 0;
  const inClaims          = loweredSegments.includes('claims');
  const currentApp_       = currentApp({ hostname, pathname });
  const isClaimsApp       = (currentApp_ && [App.CLAIMS_DIS, App.CLAIMS_BBC_APR, App.TRACKER].includes(currentApp_)) ?? false;
  const isAdminApp        = (currentApp_ && [App.DEVELOPER_TOOLS, App.HUD, App.HEALTH_CHECK].includes(currentApp_)) ?? false;
  const index             = loweredSegments.indexOf('claims');
  const claimId           = (inClaims && loweredSegments[index + 1]) ? segments[index + 1] : undefined;
  const isAppNoAccessPage = loweredSegments.includes("no-access") && (!inClaims || loweredSegments[index + 2] !== "no-access");

  return {
    currentApp: currentApp_,
    isAppRoot,
    isClaimsApp,
    isAdminApp,
    inClaims,
    isAppNoAccessPage,
    claimId,
  };
};
